import InstagramSvg from '@assets/images/svg/instagram.svg';
import React from 'react';
import { View } from 'react-native';

export interface InstagramIconProps {
    size?: number;
    color?: string;
}

export const InstagramIcon = React.memo<InstagramIconProps>(function InstagramIcon({
    size = 24,
    color = '#333333',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <InstagramSvg width={size} height={size} color={color} />
        </View>
    );
});

export default InstagramIcon;


